import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "content"]
  static values = { url: String, contentType: String, filename: String }

  open() {
    this.contentTarget.innerHTML = this._spinner()
    this.dialogTarget.showModal()
    this._loadPreview()
  }

  close() {
    this.dialogTarget.close()
    this.contentTarget.innerHTML = ""
  }

  _loadPreview() {
    const type = this.contentTypeValue

    if (type.startsWith("image/")) {
      const img = new Image()
      img.className = "max-w-full max-h-[75vh] mx-auto rounded-lg"
      img.alt = this.filenameValue
      img.onload = () => { this.contentTarget.innerHTML = ""; this.contentTarget.appendChild(img) }
      img.onerror = () => { this.contentTarget.innerHTML = this._fallback() }
      img.src = this.urlValue
      return
    }

    if (type === "application/pdf") {
      const iframe = document.createElement("iframe")
      iframe.className = "w-full rounded-lg border-0"
      iframe.style.height = "75vh"
      iframe.onload = () => { this.contentTarget.querySelector(".preview-spinner")?.remove() }
      this.contentTarget.innerHTML = ""
      this.contentTarget.insertAdjacentHTML("afterbegin", this._spinner())
      this.contentTarget.appendChild(iframe)
      iframe.src = this.urlValue
      return
    }

    this.contentTarget.innerHTML = this._fallback()
  }

  _spinner() {
    return `<div class="preview-spinner flex flex-col items-center justify-center py-16 text-text-secondary">
      <svg class="animate-spin h-8 w-8 mb-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <p class="text-sm">Caricamento anteprima…</p>
    </div>`
  }

  _fallback() {
    return `<div class="text-center py-12">
      <svg class="mx-auto h-12 w-12 text-text-muted mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" /></svg>
      <p class="text-text-secondary mb-4">Anteprima non disponibile per questo tipo di file.</p>
      <a href="${this.urlValue}" class="btn btn-primary btn-sm" target="_blank">Apri in una nuova scheda</a>
    </div>`
  }
}
